import { useTheme, type ThemeChoice } from '../lib/theme.ts';

/**
 * Light / dark / system theme control for the cockpit header — a segmented-pill control
 * (brand §6: sunken track, the active option a raised nm-tile), mirroring the Admin/Design tabs.
 * Default = system; the choice persists (see lib/theme.ts).
 */
const OPTS: { value: ThemeChoice; label: string; icon: JSX.Element }[] = [
  {
    value: 'light',
    label: 'Light',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" className="h-4 w-4">
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M19.1 4.9l-1.4 1.4M6.3 17.7l-1.4 1.4" />
      </svg>
    ),
  },
  {
    value: 'dark',
    label: 'Dark',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4">
        <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
      </svg>
    ),
  },
  {
    value: 'system',
    label: 'System',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4">
        <rect x="3" y="4" width="18" height="12" rx="1.5" />
        <path d="M8 20h8M12 16v4" />
      </svg>
    ),
  },
];

export function ThemeToggle() {
  const { choice, setChoice } = useTheme();
  return (
    <div
      role="radiogroup"
      aria-label="Theme"
      className="nm-inset inline-flex items-center gap-0.5 rounded-full bg-paper p-0.5"
    >
      {OPTS.map((o) => {
        const active = choice === o.value;
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={active}
            title={o.label}
            aria-label={o.label}
            onClick={() => setChoice(o.value)}
            className={`inline-flex h-7 w-7 items-center justify-center rounded-full transition ${
              active ? 'nm-tile text-ink' : 'text-ink-2 hover:text-ink'
            }`}
          >
            {o.icon}
          </button>
        );
      })}
    </div>
  );
}
